import React, { useContext } from "react";
import { SDLCMetadataConstants, SDLCMetadataTypeGuards, } from "@sscs/types";
import { Autocomplete, FilterBar, Menu, SearchBar, Select } from "@sscs/ui";
import { capitalizeFirstLetter } from "@sscs/utils";
import { produce } from "immer";
import { CommonListFilter } from "../../../common";
import { ReportContext } from "../../../context";
import { useLazyGetServiceProvidersQuery, useLazyGetServiceTypesQuery, } from "../../../services/saasbom.api";
import { SERVICE_TYPE_TO_TEXT } from "../../../utils";
const Filter = ({ filter, onFilterChange }) => {
    var _a, _b, _c, _d, _e;
    const { reportId } = useContext(ReportContext);
    const [getProviders, { data: serviceProviders, isLoading: areProvidersLoading },] = useLazyGetServiceProvidersQuery();
    const [getTypes, { data: serviceTypes, isLoading: areServiceTypesLoading }] = useLazyGetServiceTypesQuery();
    return (React.createElement(FilterBar, { filters: [
            {
                id: "name",
                row: 1,
                control: (React.createElement(SearchBar, { id: "saasbom-name-search", value: (_a = filter.name) !== null && _a !== void 0 ? _a : "", onChange: (value) => onFilterChange(produce(filter, (draftState) => {
                        draftState.name = value === "" ? null : value;
                    })), label: "Regex search for service name", slotProps: { htmlInput: { maxLength: 256 } }, fullWidth: true })),
            },
            {
                id: "provider",
                row: 2,
                control: (React.createElement(CommonListFilter, { id: "saasbom-filter-providers", value: filter.provider, options: serviceProviders, filterName: "Provider", onOpen: () => getProviders({ ui_id: reportId }), loading: areProvidersLoading, onChange: (_event, value) => {
                        onFilterChange(produce(filter, (draftState) => {
                            draftState.provider = value;
                        }));
                    } })),
            },
            {
                id: "service-type",
                row: 2,
                control: (React.createElement(Autocomplete, { label: "Filter by service type", id: "service-type-filter", isClearAlwaysVisible: filter.type !== null, value: (_b = filter.type) !== null && _b !== void 0 ? _b : "ALL", onOpen: () => getTypes({ ui_id: reportId }), onChange: (_event, value) => onFilterChange(produce(filter, (draftState) => {
                        if (value &&
                            SDLCMetadataTypeGuards.stringIsNetworkService(value)) {
                            draftState.type = value;
                        }
                        else {
                            draftState.type = null;
                        }
                    })), options: ["ALL", ...((_c = serviceTypes === null || serviceTypes === void 0 ? void 0 : serviceTypes.service_types) !== null && _c !== void 0 ? _c : [])], loading: areServiceTypesLoading, getOptionLabel: (option) => {
                        return option === "ALL"
                            ? "Show all service types"
                            : SERVICE_TYPE_TO_TEXT[option];
                    } })),
            },
            {
                id: "flow",
                row: 2,
                control: (React.createElement(Select, { label: "Filter by service flow", id: "service-flow-filter", labelId: "service-flow-filter-label", displayEmpty: true, shrinkLabel: true, value: (_d = filter.flow) !== null && _d !== void 0 ? _d : "ALL", onChange: (value) => onFilterChange(produce(filter, (draftState) => {
                        if (SDLCMetadataTypeGuards.stringIsNetworkFlow(value)) {
                            draftState.flow = value;
                        }
                        else {
                            draftState.flow = null;
                        }
                    })) },
                    React.createElement(Menu.Item, { id: "show-all-service-flows", value: "ALL" }, "Show all service flows"),
                    SDLCMetadataConstants.networkFlow.map((serviceFlow) => (React.createElement(Menu.Item, { key: serviceFlow, id: `filter-by-${serviceFlow}`, value: serviceFlow }, capitalizeFirstLetter(serviceFlow)))))),
            },
            {
                id: "auth",
                row: 2,
                control: (React.createElement(Select, { label: "Filter by service auth", id: "service-auth-filter", labelId: "service-auth-filter-label", displayEmpty: true, shrinkLabel: true, value: (_e = filter.auth) !== null && _e !== void 0 ? _e : "ALL", onChange: (value) => onFilterChange(produce(filter, (draftState) => {
                        if (value === "true") {
                            draftState.auth = true;
                        }
                        else if (value === "false") {
                            draftState.auth = false;
                        }
                        else {
                            draftState.auth = null;
                        }
                    })) },
                    React.createElement(Menu.Item, { id: "show-all-service-auths", value: "ALL" }, "Show all authentication options"),
                    React.createElement(Menu.Item, { id: `filter-by-requires-auth`, value: "true" }, "Requires auth"),
                    React.createElement(Menu.Item, { id: `filter-by-does-not-require-auth`, value: "false" }, "Does not require auth"))),
            },
        ] }));
};
export default Filter;
//# sourceMappingURL=Filter.js.map